import React, { useEffect, useRef } from 'react';

export interface MobileSelectOption {
	value: string;
	label: string;
}

interface MobileSelectProps {
	label?: string;
	value: string;
	options: MobileSelectOption[];
	onChange: (value: string) => void;
	placeholder?: string;
}

const MobileSelect: React.FC<MobileSelectProps> = ({ label, value, options, onChange, placeholder }) => {
	const [open, setOpen] = React.useState(false);
	const sheetRef = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		const onKey = (e: KeyboardEvent) => {
			if (e.key === 'Escape') setOpen(false);
		};
		document.addEventListener('keydown', onKey);
		return () => document.removeEventListener('keydown', onKey);
	}, []);

	return (
		<div>
			{label && <label className="block text-sm text-gray-700 mb-1">{label}</label>}
			<button
				type="button"
				onClick={() => setOpen(true)}
				className="w-full border rounded px-3 py-2 flex items-center justify-between bg-white"
			>
				<span className={`text-sm ${value ? 'text-gray-900' : 'text-gray-400'}`}>
					{value ? options.find(o => o.value === value)?.label : (placeholder || 'Select')}
				</span>
				<svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
				</svg>
			</button>

			{open && (
				<div className="fixed inset-0 z-[100] flex flex-col justify-end bg-black/50 pb-safe" onClick={() => setOpen(false)}>
					<div ref={sheetRef} className="bg-white rounded-t-2xl shadow-lg max-h-[70vh] overflow-hidden" onClick={e => e.stopPropagation()}>
						<div className="p-4 border-b flex items-center justify-between">
							<div className="w-6 h-6" />
							<div className="font-semibold">{label || 'Select'}</div>
							<button className="text-primary" onClick={() => setOpen(false)}>Done</button>
						</div>
						<div className="overflow-auto overscroll-contain">
							{options.map(opt => {
								const active = opt.value === value;
								return (
									<button
										key={opt.value}
										onClick={() => { onChange(opt.value); setOpen(false); }}
										className={`w-full text-left px-4 py-3 border-b ${active ? 'bg-primary/10 text-primary font-medium' : 'bg-white'}`}
									>
										{opt.label}
									</button>
								);
							})}
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default MobileSelect;


